import { twMerge } from 'tailwind-merge';

import { resolvePath } from '@/utils/helpers';

import { Link, LinkProps } from '../../Link';

import { StoreCardContextProvider } from './store-card-context';

export type RootProps = Omit<LinkProps, 'href'> & {
  store: AdaptedStore | AdaptedStore<true>;
};

export function Root({ store, className, ...props }: RootProps) {
  const storeProfileHref = resolvePath({ pathname: store.zmyleUri });

  return (
    <StoreCardContextProvider store={store}>
      <Link
        className={twMerge(
          'flex flex-col gap-3 rounded-md bg-white px-4 pb-8 shadow-xl lg:gap-6',
          'hover:ring-store-primary ring-2 ring-transparent',
          'transition-colors',
          className,
        )}
        variant="ghost"
        href={storeProfileHref}
        {...props}
      />
    </StoreCardContextProvider>
  );
}
